import React from "react";

import { FormControl, FormHelperText, TextField } from "@mui/material";

import MouseOverPopover from "components/MouseOverPopover";

import { HELP_LINKS_BY_DESTINATION } from "../../DestinationCreation.constants";
import {
    getPixelIdLabel,
    getPixelIdPlaceholder,
} from "../../DestinationCreation.helpers";
import HelpPopoverCard from "../HelpPopoverCard";

const PixelIdField = ({
    destinationCode,
    value,
    error,
    isInputVisible,
    language,
    onChange,
}) => {
    const helpLink = HELP_LINKS_BY_DESTINATION[destinationCode]?.pixelId;
    const hasHelp = destinationCode in HELP_LINKS_BY_DESTINATION;

    return (
        <FormControl
            className="mb-3 mouse-over-popover-area"
            style={{ width: "100%" }}
            error={Boolean(error)}
        >
            {isInputVisible && (
                <TextField
                    name="pixel_id"
                    inputProps={{ "data-cy": "create-destination-pixel-id" }}
                    label={getPixelIdLabel(destinationCode, language)}
                    variant="outlined"
                    onChange={onChange}
                    value={value}
                    placeholder={getPixelIdPlaceholder(
                        destinationCode,
                        language,
                    )}
                    error={Boolean(error)}
                />
            )}
            {error && (
                <FormHelperText>
                    {language?.source_modal?.validation_error ??
                        "Validation Error"}
                </FormHelperText>
            )}
            {hasHelp && (
                <MouseOverPopover
                    text={
                        <HelpPopoverCard
                            title={
                                language?.popover?.to_create_pixel_id ??
                                "To Create Pixel Id"
                            }
                            description={
                                language?.popover?.how_to_find_pixel ??
                                "How to find pixel ID? Please refer to the link:"
                            }
                            link={helpLink}
                            language={language}
                        />
                    }
                />
            )}
        </FormControl>
    );
};

export default PixelIdField;
